
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create",
      function () {
        return require("private-next-pages/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create"])
      });
    }
  